import "fslightbox";
jQuery(document).ready(function () {
    refreshFsLightbox();
});
